import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';
import { X } from 'lucide-react';

/**
 * Language Selection Banner - non-blocking floating banner on first visit
 * Helps native Cebuano speakers switch to their preferred language
 * without blocking the page content
 */
const LanguageSelectionModal = () => {
  const { i18n } = useTranslation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      const hasSelectedLanguage = localStorage.getItem('language_selected');
      if (!hasSelectedLanguage) {
        // Small delay so the page renders first
        const showTimer = setTimeout(() => setShow(true), 800);
        // Auto-dismiss after 10 seconds (10s + 0.8s initial delay)
        const hideTimer = setTimeout(() => {
          setShow(prev => {
            if (prev) {
              // Auto-dismiss = keep English default
              try {
                localStorage.setItem('language', 'en');
                localStorage.setItem('language_selected', 'true');
              } catch {}
            }
            return false;
          });
        }, 10800);
        return () => {
          clearTimeout(showTimer);
          clearTimeout(hideTimer);
        };
      }
    } catch {
      // localStorage blocked, don't show
    }
  }, []);

  const selectLanguage = (lng) => {
    i18n.changeLanguage(lng);
    try {
      localStorage.setItem('language', lng);
      localStorage.setItem('language_selected', 'true');
    } catch {}
    setShow(false);
  };

  const dismiss = () => {
    // Dismiss = keep English (default)
    try {
      localStorage.setItem('language', 'en');
      localStorage.setItem('language_selected', 'true');
    } catch {}
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-2 left-2 right-2 z-[100] md:left-auto md:right-4 md:bottom-4 md:w-80 animate-in slide-in-from-bottom duration-300">
      <div className="bg-white dark:bg-gray-900 rounded-xl shadow-lg border p-3">
        <div className="flex items-center justify-between gap-2 mb-2">
          <p className="text-sm font-medium text-gray-700 dark:text-gray-300">
            Bisaya ka? / Choose language
          </p>
          <Button
            onClick={dismiss}
            variant="ghost"
            size="icon"
            className="h-7 w-7 flex-shrink-0"
          >
            <X size={14} />
          </Button>
        </div>
        <div className="flex gap-2">
          <Button
            onClick={() => selectLanguage('ceb')}
            variant="outline"
            size="sm"
            className="flex-1 font-semibold border-2 hover:border-primary hover:bg-primary/5"
          >
            Bisaya
          </Button>
          <Button
            onClick={() => selectLanguage('en')}
            variant="outline"
            size="sm"
            className="flex-1 font-semibold border-2 hover:border-primary hover:bg-primary/5"
          >
            English
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LanguageSelectionModal;
